// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
import React, {Component, PropTypes} from 'react';

// Redux stuff
import { connect } from 'react-redux';

// utilities
import _, {get} from 'lodash';
import moment from 'moment';
import cx from 'classnames';
import prettyDate from '../../../lib/prettyDate';

// Async actions
import {
  submitEvent
} from '../../../redux/actionCreators/async';

// components
import EventsList from './f_EventsList';
import AddTaskForm from './c_AddTaskForm';
import AddNoteForm from './c_AddNoteForm';
import DateInput from '../../../common/components/DateInput';
import ChevronIcon from '../../../common/svgs/ChevronIcon';
import StatusFilter from '../../../common/components/StatusFilter';

// HJP 2018-04-19: The following table should be in the DB, NOT hard-coded
// Added TechnologySurvey
const categories = [
  {id: 'Preliminary', name: 'Preliminary Profile Interview'},
  {id: 'Review', name: 'Review'},
  {id: 'Interview', name: 'Interview'},
  {id: 'References', name: 'References'},
  {id: 'TechnologySurvey', name: 'Technology Survey'},
];


@connect(store => {
  return {
    viewOrder: get(store, 'labels.viewOrder', [])
  };
}, ({
  submitEvent
})) // gives dispatch function
export default class Events extends Component {
  static propTypes = {
    submitEvent: PropTypes.func.isRequired,
    applicant: PropTypes.object.isRequired,
    applicantStatusColor: PropTypes.string.isRequired,
    show: PropTypes.bool,
    style: PropTypes.object,
    taskTypes: PropTypes.array,
    taskResultTypes: PropTypes.array,
    alertsList: PropTypes.array,
    route: PropTypes.object.isRequired,
    viewOrder: PropTypes.object.isRequired,
  }

  state = {
    activeSection: 'task',
    addEventToggled: false,
    selectedItem: null,
    editMode: false,
    selectedCategories: [],
    filterDate: null,
    sortField: 'dateCreated',
    sortDescending: true,
  }

  toggleShow(section) {
    this.setState(_.merge({}, this.state, {
      activeSection: section,
      selectedCategories: [],
      filterDate: null,
      sortField: 'dateCreated',
      sortDescending: true,
      addEventToggled: false,
    }));
  }

  toggleSort(sortField) {
    if (this.state.sortField === sortField) {
      this.setState(_.merge({}, this.state, {
        sortDescending: !this.state.sortDescending,
      }));
    }
    else {
      this.setState(_.merge({}, this.state, {
        sortField,
        sortDescending: true,
      }));
    }
  }

  toggleAdd() {
    this.setState(_.merge({}, this.state, {
      addEventToggled: !this.state.addEventToggled,
      selectedItem: null,
      editMode: false,
    }));
  }

  submitTask(task) {
    if(this.state.editMode) {
      task.taskId = this.state.selectedItem.id;
      this.props.submitEvent('tasks', task, {type: 'edit', param: this.state.selectedItem.id});
    }else{
      this.props.submitEvent('tasks', task);
    }

    this.setState({ selectedItem: null, editMode: false, addEventToggled: false });
  }

  submitNote(note) {

    if(this.state.editMode) {
      note.noteId = this.state.selectedItem.id;
      this.props.submitEvent('notes', note, {type: 'edit', param: this.state.selectedItem.id});
    }else{
      this.props.submitEvent('notes', note);
    }

    this.setState({ selectedItem: null, editMode: false, addEventToggled: false });
  }

  handleClick(item) {
    if(item) {
      this.setState({ selectedItem: item, editMode: true, addEventToggled: true });
    }
  }

  handleCategoryFilter = (e, values) => {
    this.setState({ selectedCategories: values });
  }

  handleDate = (e, value) => {
    this.setState({ filterDate: value });
  }

  render() {
    // yank vars off state
    const {
      activeSection,
      addEventToggled,
      selectedCategories,
      filterDate,
      sortField,
      sortDescending,
    } = this.state;

    // combine event properties and sort by date
    const eventArray = _([])
      .concat(activeSection !== 'note' ? (this.props.applicant.profile.tasks || []) : [])
      .concat(activeSection !== 'task' ? (this.props.applicant.profile.notes || []) : [])
      .filter(e => filterDate ? moment(e.dateCreated).format('YYYY-MM-DD') === moment(filterDate).format('YYYY-MM-DD') : e)
      .filter(e => selectedCategories ? _.isEmpty(selectedCategories) || !!~selectedCategories.indexOf(e.category) : e);

    const eventList = activeSection === 'task'
      ? eventArray.orderBy(['closed', sortField], ['asc', sortDescending ? 'desc' : 'asc']).value()
      : eventArray.orderBy([sortField], [sortDescending ? 'desc' : 'asc']).value();

    const alertsStyle = {
      height: global.innerHeight - 50
    };

  let catgoryDescription = '';
	if(this.props.route.params.category) {
    catgoryDescription = (this.props.viewOrder[this.props.viewOrder.findIndex(category => category.key === this.props.route.params.category)] || {}).display;
	}
  else {
    // Specially references section.
    catgoryDescription = _.last(this.props.route.current.split('/'));
  }
    return (
      <div className={cx('alerts-container', 'clearfix', activeSection)}
        key={`Events ${this.props.applicant.profile.id}`}
        style = { alertsStyle }>
        <div className='alerts-nav'>
          <div data-id='Tasks'
               className={cx('alerts-nav-item', 'noTextSelect', {active: activeSection === 'task'})}
               onClick={this.toggleShow.bind(this, 'task')}>
            <div className='alerts-nav-text noTextSelect'>
              Tasks
            </div>
          </div>
          <div data-id='Notes'
               className={cx('alerts-nav-item', {active: activeSection === 'note'})}
               onClick={this.toggleShow.bind(this, 'note')}>
            <div className='alerts-nav-text noTextSelect'>
              Notes
            </div>
          </div>
          <div data-id='All'
               className={cx('alerts-nav-item', {active: activeSection === 'all'})}
               onClick={this.toggleShow.bind(this, 'all')}>
            <div className='alerts-nav-text noTextSelect'>
              All
            </div>
          </div>
        </div>
        <div className={cx('event-container', {toggled: addEventToggled})}>
          {
            activeSection !== 'all'
            &&
            <div data-id='Add Event'
               className={cx('add-event', {toggled: addEventToggled})}
               onClick={!addEventToggled && this.toggleAdd.bind(this)}>
            {
              !addEventToggled
              &&
              <div className='event-heading-wrapper'>
                <div className='add-event-text noTextSelect'>
                  Add { activeSection === 'task'? 'Task' : 'Note' }
                </div>
              </div>
            }
            {
              addEventToggled
              &&
              <div className='event-wrapper'>
                <div className='event-heading-wrapper'>
                  <div data-id='Add Task' className={cx('add-event-text', 'task', 'noTextSelect', 'active-add')}>
                    Add { activeSection === 'task'? 'Task' : 'Note' }
                  </div>
                  <div data-id='Close' className='plus noTextSelect' onClick={this.toggleAdd.bind(this)}>
                    +
                  </div>
                </div>
                <div className={cx('add-event-form', activeSection)}>
                  <div className='current-date'>
                    {prettyDate(_.get(this.state.selectedItem, 'dateCreated', new Date()))}
                  </div>
                  {
                    activeSection === 'task'
                    &&
                    <AddTaskForm
                      applicantId={this.props.applicant.profile.id}
                      submitTask={::this.submitTask}
                      taskTypes={this.props.taskTypes}
                      taskResultTypes={this.props.taskResultTypes}
                      category={catgoryDescription}
                      selectedItem={this.state.selectedItem}
                    />
                    ||
                    <AddNoteForm
                      applicantId={this.props.applicant.profile.id}
                      applicantStatusId={this.props.applicant.profile.applicantStatus.id}
                      submitNote={::this.submitNote}
                      category={catgoryDescription}
                      categories={categories}
                      color={this.props.applicantStatusColor}
                      selectedItem={this.state.selectedItem}
                    />
                  }
                </div>
              </div>
            }
          </div>
          }
          {
            <div className='notes-filter-wrapper'>
              <div className='notes-sort'>
                {
                  activeSection !== 'note'
                  &&
                  <div data-id='Follow Up Date' className='sort-field follow-up-date' onClick={this.toggleSort.bind(this, 'taskFollowUpDate')} >Follow Up Date
                    <div className={cx('chevron', {
                          descending: this.state.sortField === 'taskFollowUpDate' && this.state.sortDescending,
                          ascending: this.state.sortField === 'taskFollowUpDate' && !this.state.sortDescending,
                        })}
                     >
                      <ChevronIcon/>
                    </div>
                  </div>
                }
                <div data-id='Date Added' className='sort-field updated-date' onClick={this.toggleSort.bind(this, 'dateCreated')} >Date Added
                  <div className={cx('chevron', {
                        descending: this.state.sortField === 'dateCreated' && this.state.sortDescending,
                        ascending: this.state.sortField === 'dateCreated' && !this.state.sortDescending,
                      })}
                  >
                    <ChevronIcon/>
                  </div>
                </div>
              </div>
              <div className='notes-filter'>
                <DateInput
                  data-id={'Filter Notes By Date'}
                  autoOk
                  onChange={ this.handleDate }
                />
              <StatusFilter
                  menuItems={categories}
                  onChange={::this.handleCategoryFilter}
                />
              </div>
            </div>
          }
          <EventsList
              list={eventList}
              activeSection={this.state.activeSection}
              category={catgoryDescription}
              handleClick={this.handleClick.bind(this)}
              />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/r_ExpandedCard/r_Events/index.js